import { SDate } from '@summit/core';
import { SummitFormattedText } from '@summit/models';
import { ReconcileFlags } from '../reconcile-flags.enum';
import { ReconcileViewModel } from '../reconcile-view-model';
import { DisputeReconcile } from './dispute-reconcile';
import { DisputeStatusMapping } from './dispute-status.enum';
import { InvestigatingStatus, InvestigatingStatusMapping } from './investigating-status.enum';

export class MissingRevenue extends ReconcileViewModel {
  estMiles: number;
  missingRevenue: number;

  investigatingStatus: InvestigatingStatus;
  disputeReconciles: DisputeReconcile[];
  revenueComment: string;
  private _flagSummary: SummitFormattedText;

  constructor(jsonData?: Partial<MissingRevenue>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.settlementDate) this.settlementDate = SDate.new(jsonData.settlementDate);
      if (jsonData.disputeReconciles)
        this.disputeReconciles = jsonData.disputeReconciles.map((reconcile) => new DisputeReconcile(reconcile));
    }
    this.flags ??= ReconcileFlags.None;
    this.investigatingStatus ??= InvestigatingStatus.Investigating;
    this.disputeReconciles ??= [];
  }

  get flagSummary(): SummitFormattedText {
    if (this._flagSummary === undefined) {
      this._flagSummary = new SummitFormattedText();
      //response.AddLine(`Flag ${this.flags}`);
      if (this.flags & ReconcileFlags.SettlementJump) this._flagSummary.AddLine('Settlement Jump');
      if (this.flags & ReconcileFlags.SettlementMissing) this._flagSummary.AddLine('Settlement Missing');
      if (this.flags & ReconcileFlags.MissedStop) this._flagSummary.AddLine('Missing Stop');
      if (this.flags & ReconcileFlags.MissedFuel) this._flagSummary.AddLine('Missing Fuel Subsidy');
      if (this.flags & ReconcileFlags.MissedDH) this._flagSummary.AddLine('Missing Drop & Hook');
      if (this.flags & ReconcileFlags.DeltaMiles) this._flagSummary.AddLine('Mileage Difference');
      if (this.flags & ReconcileFlags.DeltaDH) this._flagSummary.AddLine('Drop & Hook Difference');
      if (this._flagSummary.isEmpty()) this._flagSummary = null;
    }
    return this._flagSummary;
  }

  get combinedComment(): SummitFormattedText {
    const response = new SummitFormattedText();
    const commentSummary = this.commentSummaryFormatted;
    if (!commentSummary.isEmpty()) {
      if (this.revenueComment?.length > 0) response.AddLine('Trip Comment:', ['font-bold']);
      response.AddText(commentSummary);
    }
    if (this.revenueComment?.length > 0) {
      response.AddLine('Revenue Comment:', ['font-bold']);
      response.AddLine(this.revenueComment);
    }
    return response.isEmpty() ? null : response;
  }

  get missingMiles(): number {
    if (!this.estMiles) return null;
    return this.estMiles - this.settlementMiles;
  }
  get name(): string {
    return `${this.employee.name}`;
  }

  private _statusSummary: SummitFormattedText;
  get statusSummary(): SummitFormattedText {
    if (this._statusSummary === undefined) {
      this._statusSummary = new SummitFormattedText();
      this._statusSummary.AddLine(InvestigatingStatusMapping[this.investigatingStatus]);
      if (this.disputeReconciles?.length > 0) {
        this.disputeReconciles.forEach((disputeReconcile) => {
          if (disputeReconcile.dispute) {
            const dispute = disputeReconcile.dispute;
            //console.log('dispute', dispute);
            this._statusSummary.AddLine(
              `=> ${DisputeStatusMapping[dispute.status]}`,
              ['flex', 'flex-row', 'justify-end'],
              {
                protocol: 'https',
                path: ['/', 'reconcile', 'disputes', dispute.id]
              }
            );
          }
        });
      }
    }
    return this._statusSummary;
  }
}
